import React from 'react';
import { useStableParams } from '../../../routes/useStableParams';
import AsoLayers from './AsoLayers';

const AsoGlobalLayers: React.FC = () => {
  const { asoScenarioId } = useStableParams();

  if (!asoScenarioId) return null;

  return <AsoLayers asoScenarioId={asoScenarioId} variant="global" />;
};

export default AsoGlobalLayers;
